import { IDashboardCard } from "@/shared/api/onboarding"
import { ColumnDef } from "@tanstack/react-table"
import { Table } from "@/shared/ui/table"
import { Loader } from "@/shared/ui/loader"
import { NoTableData } from "@/shared/ui/no-table-data"
import { FC } from "react"
import { useNavigate } from "react-router-dom"
import { ActionButton } from "@/shared/ui/action-button"
import ArrowLeftSvg from '@/shared/assets/images/ArrowBendDownRight.svg'

interface BusinessCardsTableProps {
    cards: IDashboardCard[]
    isLoading: boolean
}

const getPaymentSystemIcon = (paymentSystem: string): string => {
    const system = paymentSystem.toLowerCase()
    if (system.includes('visa')) return 'VISA'
    if (system.includes('mastercard')) return 'Mastercard'
    if (system.includes('mir')) return 'МИР'
    return paymentSystem
}

const formatCardNumber = (number: string): string => {
    if (!number) return ''
    const last4 = number.slice(-4)
    return `•••• ${last4}`
}

export const BusinessCardsTable: FC<BusinessCardsTableProps> = ({ cards, isLoading }) => {
    const navigate = useNavigate()

    const columns: ColumnDef<IDashboardCard, any>[] = [
        {
            accessorFn: (card) => (
                <div className="w-full flex items-center">
                    <div className="px-3 py-1 bg-gray-100 rounded text-sm font-semibold">
                        {getPaymentSystemIcon(card.paymentSystemTypeName || 'Unknown')}
                    </div>
                </div>
            ),
            enableSorting: false,
            id: 'paymentSystem',
            cell: info => info.getValue(),
            header: () => <div className="!text-start text-nowrap">Платёжная система</div>,
        },
        {
            accessorFn: (card) => (
                <div className="w-full">
                    {formatCardNumber(card.number)}
                </div>
            ),
            id: 'number',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div className="!text-start text-nowrap">Номер карты</div>,
        },
        {
            accessorFn: (card) => (
                <div className="w-full">
                    {card.bankTypeName || 'Не указан'}
                </div>
            ),
            id: 'bank',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div className="!text-start text-nowrap">Банк</div>,
        },
        {
            accessorFn: () => {
                return (
                    <div className="w-full">
                        <span className={`px-3 py-1 rounded text-sm font-semibold bg-green-100 text-green-800`}>
                            Активна
                        </span>
                    </div>
                )
            },
            enableSorting: false,
            id: 'status',
            cell: info => info.getValue(),
            header: () => <div className="!text-start text-nowrap">Статус</div>,
        },
        {
            accessorFn: (card) => (
                <div className="w-full flex justify-end gap-2">
                    <ActionButton
                        onClick={() => navigate(`/business-cards/${card.id}`)}
                        icon={ArrowLeftSvg}
                    />
                </div>
            ),
            id: 'actions',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div/>,
        },
    ]

    return (
        <>
            {Boolean(cards.length) &&
                <div className="table_box">
                    <Table columns={columns} data={cards} />
                </div>
            }
            {(!Boolean(cards.length) && isLoading) &&
                <div className="info_panel">
                    <Loader />
                </div>
            }
            {(!Boolean(cards.length) && !isLoading) &&
                <NoTableData label="Нет данных о картах" />
            }
        </>
    )
}

